import React from 'react';
import PureComponent from 'components/PureComponent';
import cookie from "react-cookies";
import { Link } from 'react-router';
import Button from 'components/Button';

class MenuButton extends PureComponent {
	render() {
		require('./MenuButton.styl');


        const city = cookie.load('city');

		return (
			<div className="MenuButtonContainer">
				{city &&
					<Link to="/city" className="MenuButtonContainer__link">
						<span>{city}</span>
					</Link>
				}

                <a className="MenuButton" {...this.props}>
                    {/*<span className="MenuButton__lbl">{city ? "" : "Меню"}</span>*/}
                    <i className="MenuButton__icon" />
                </a>
			</div>
		);
	}
}

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/MenuButton/MenuButton.js